<template>
  <div id="app">
    <messages />
    <navBar />
    <div class="container-fluid">
      <div
        class="row"
        v-if="onUploadPage || (!newProviderPosted && isCreateMode)"
      >
        <div class="col-md-offset-1 col-md-10">
          <router-view id="content" />
        </div>
      </div>
      <div v-else class="row">
        <div class="col-md-2">
          <sideNav v-if="authenticated && !isNullMode && !onUploadPage" />
        </div>
        <div class="col-md-10">
          <router-view id="content" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import sideNav from "./elements/sideNav.vue";
import messages from "./elements/messages.vue";
import logo from "./elements/logo.vue";
import navBar from "./elements/navBar.vue";

export default {
  name: "app",
  components: {
    sideNav: sideNav,
    messages: messages,
    logo: logo,
    navBar: navBar
  },
  computed: {
    ...mapGetters({
      authenticated: "authenticated",
      newProviderPosted: "newProviderPosted",
      isNullMode: "isNullMode",
      oneTimeAccess: "oneTimeAccess",
      isCreateMode: "isCreateMode"
    }),
    onUploadPage: function() {
      return this.$route.name == "gcic-page";
    }
  },
  methods: {
    ...mapActions(["addMessage"])
  }
};
</script>

<style>
@import "./assets/style.css";

#content {
  margin-top: 10px;
  margin-bottom: 100px;
  padding: 10px 30px;
}
.wrapper {
  display: flex;
  justify-content: space-between;
}

.header-link {
  float: right;
  font-size: 15px;
  text-align: center;
  padding: 15px 10px;
  text-decoration: none;
  display: inline-block;
  margin-left: 13px;
  margin-right: 13px;
  border-radius: 10px;
  background-color: white;
  -webkit-transition-duration: 0.4s;
  transition-duration: 0.4s;
  cursor: pointer;
}

.header-link:hover {
  background-color: lightgrey;
  text-decoration: none;
}

.header-logo {
  float: left;
  padding: 2px 10px;
  font-size: 35px;
}

.navbar {
  overflow: hidden;
  border-style: solid;
  border-bottom: 1px solid black;
  border-radius: 0;
}

.navbar .links {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/App.vue